import React, { useContext } from "react";
import { CollapsibleBox } from ".";
import { FormattedMessage } from "react-intl-phraseapp";
import { TealiumEventProps } from "../helpers/objectUtilities";
import { PreviewContext } from "../helpers";
import { PlanDetailsSection } from "../@types";

interface PlanDetailListWithHelpDrawerProps {
  id: PlanDetailsSection;
  helpId?: string;
  helpContent?: JSX.Element;
  tealiumProps?: TealiumEventProps;
  titleId: string;
}

const PlanDetailListWithHelpDrawer: React.FunctionComponent<PlanDetailListWithHelpDrawerProps> = ({
  children,
  id,
  helpId,
  helpContent,
  tealiumProps,
  titleId,
}) => {
  const previewMode = useContext(PreviewContext);

  return (
    <div>
      <h2 className="PlanDetailList__header" id={id} tabIndex={-1}>
        <CollapsibleBox
          labelId={titleId}
          titleClassname="PlanDetailList__header"
          contentClassname="PlanDetailList__definition"
          tealiumProps={
            tealiumProps
              ? {
                  event_action: tealiumProps.event_action,
                  event_label: tealiumProps.event_label,
                }
              : undefined
          }
          open={previewMode}
        >
          {helpContent && helpContent}
          {helpId && <FormattedMessage id={helpId} tagName="p" />}
        </CollapsibleBox>
      </h2>
      <div className="PlanDetailList__list">{children}</div>
    </div>
  );
};

export default PlanDetailListWithHelpDrawer;
